export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";